import { Select } from '@loadsmart/loadsmart-ui'
import { Selectable } from '@loadsmart/loadsmart-ui/dist/hooks/useSelectable'
import { GatewaySetting } from 'common/types/kraken-core/GatewaySettings'
import isEmpty from 'lodash.isempty'
import { onSearchGateways } from 'molecules/JsonForm/renderers/EntitySelector/datasource'
import { useGetGatewaySettings } from 'pages/Gateway/api'
import { useEffect, useState } from 'react'

export interface GatewaySettingsSelectorProps {
  selected?: {
    label?: string
    id?: string
  }
  onSelect: (selected: GatewaySetting) => void
}

const DATASOURCES = {
  GATEWAY_SETTINGS: [
    () => ({
      type: 'string',
      adapter: {
        getKey: (entity: GatewaySetting) => entity.id || '',
        getLabel: (entity: GatewaySetting) => entity.name || '',
      },
      fetch: onSearchGateways,
    }),
  ],
}

export default function GatewaySettingsSelector(props: GatewaySettingsSelectorProps) {
  const [selected, setSelected] = useState<any>({
    value: props.selected?.id,
    label: props.selected?.label,
  })

  const { data } = useGetGatewaySettings(
    {
      id: selected ? selected.value : '',
    },
    {
      enabled: Boolean(selected) && !isEmpty(selected.value),
    }
  )

  useEffect(() => {
    if (data) {
      setSelected((c: any) => ({
        value: data.id,
        label: data.name,
      }))
    }
  }, [data])

  return (
    <Select
      id="select"
      name="select"
      onChange={e => props.onSelect(e.target.value as GatewaySetting)}
      value={selected as Selectable}
      datasources={DATASOURCES.GATEWAY_SETTINGS}
      placeholder="Select a gateway settings"
    />
  )
}
